import React, { useRef, useEffect, useState } from "react";
import Proptypes from "prop-types";
import cn from "classnames";
import { getBoundingRelativeRect } from "lib/visual";

/**
 * при наведении на потомка выводит поап с подсказкой
 *
 * @param {string} message - текст, который будет всплывать
 * @param children - узел, который будет вызывать  всплытие попапа
 * @param {string} placement - с какой стороны будет всплывать "top", "right", "bottom"
 * @param {object} styles - объект со стилями
 * @param boundaryParent- DOM элемент, в который должен вписываться тултип. Пока проверка работает только для placement="top"
 */

const Tooltip = ({ message, children, placement, styles, boundaryParent }) => {
    const $popup = useRef(null);
    //надеемся на то, что во время использования никто не поменяет пропс placement
    const [fixedPlacement, setFixedPlacement] = useState(placement);

    useEffect(() => {
        if (boundaryParent) {
            const relativeRect = getBoundingRelativeRect(
                $popup.current,
                boundaryParent
            );

            if (fixedPlacement === "top" && fixedPlacement === placement) {
                if (relativeRect.top < 0) {
                    setFixedPlacement("bottom");
                }
            } else if (
                fixedPlacement === "bottom" &&
                fixedPlacement === placement
            ) {
                if (relativeRect.bottom > 0) {
                    setFixedPlacement("top");
                }
            }
        }
    }, [boundaryParent, fixedPlacement]);

    useEffect(() => {
        if (["top", "bottom"].includes(fixedPlacement)) {
            const padding = 16;
            let rect = $popup.current.getBoundingClientRect();
            const width = rect.right - rect.left;
            const screenWidth = window.screen.width;

            if (width + padding * 2 > screenWidth) {
                $popup.current.style.width = screenWidth - padding * 2 + "px";
                rect = $popup.current.getBoundingClientRect();
            }

            const offsetRight = rect.right + padding - screenWidth;
            const offsetLeft = rect.left - padding;

            if (offsetRight > 0) {
                $popup.current.style.transform = `translateX(calc(-50% - ${offsetRight}px))`;
            } else if (offsetLeft < 0) {
                $popup.current.style.transform = `translateX(calc(-50% - ${offsetLeft}px))`;
            }
        }
    }, [fixedPlacement]);

    return (
        <div className="tooltip">
            <div
                className={cn(
                    `tooltip__btn tooltip__btn_placement-${fixedPlacement}`
                )}
            >
                {children}
            </div>

            <div
                className={`tooltip__popup tooltip__popup_${fixedPlacement} popup`}
                ref={$popup}
                style={styles?.popup}
            >
                {message}
            </div>
        </div>
    );
};

Tooltip.defaultProps = {
    placement: "right",
    styles: {},
};

Tooltip.propTypes = {
    message: Proptypes.any.isRequired,
    children: Proptypes.any.isRequired,
    placement: Proptypes.oneOf(["top", "right", "bottom"]),
    styles: Proptypes.shape({
        popup: Proptypes.object,
    }),
    boundaryParent: Proptypes.node,
};

export default Tooltip;
